import { useApmmRouterConfig } from './router/router-config';
import { useWallet } from '@/client/hooks/use-wallet';
import { canResumeTransaction, useTransactionStore } from '@/client/store/transaction-store';

/**
 * True while a router buy or sell of this market runs for the connected account on its chain: the side,
 * the option and the amount must not change under it. A claim, a record of another market, account or
 * chain, and a record that can be resumed (no flow runs for it) do not lock. Always false with the switch off.
 */
export const useTradeLock = (marketAddress: string): boolean => {
  const routerOn = useApmmRouterConfig().status === 'on';
  const { walletClient } = useWallet();
  const account = walletClient?.account?.address;
  const chainId = walletClient?.chain?.id;
  const active = useTransactionStore(state => (account && chainId ? state.findActive(chainId, account) : undefined));
  return (
    routerOn &&
    !!active &&
    (active.operation === 'buy' || active.operation === 'sell') &&
    active.marketAddress.toLowerCase() === marketAddress.toLowerCase() &&
    !canResumeTransaction(active)
  );
};
